/* NDC (04.10): „Comandă pe WhatsApp” de pe pagina de produs.
   Butonul [data-ndc-wa] are și data-ndc-buy → ndc-personalizer.js verifică întâi textul + macheta (ca la „Comandă acum”);
   serviciile bifate nu intră în coș (vezi captura de mai jos), doar în mesaj. Dacă e totul în regulă, ajungem aici: fereastra cu datele de livrare →
   WhatsApp (wa.me) cu mesajul gata scris. Ultima linie „Cod: NDC-<variantă>[-S<serviciu>…]-<control>” o citește
   scriptul (webhook 0756) și creează comanda în Shopify. Codul de control = FNV-1a pe datele comenzii → scriptul vede
   dacă mesajul a fost modificat (comanda se creează oricum, cu notă „text modificat”).
   ATENȚIE: formatul mesajului și ndcWaCanon() trebuie să rămână identice cu NDC-wa-comenzi.gs (ndcWaCanon_).
   NDC HU (16.10, C+2c): dialogul cu data-lang="hu" (/hu-hu/) → sume în Ft (prețul variantei = HUF din Liquid), transport fix
   data-ship (2 990 Ft), fără prag / județ / locker; mesaj în maghiară, plata cu cardul prin link trimis pe WhatsApp;
   ultima linie „Kód: NDC-HU-<variantă>[-S<serviciu>…]-<control>” (webhook-ul RO NU o recunoaște → etapa E = flux HU separat).
   Canon HU (pentru E, ndcWaCanonHu_): v # servicii # props # nume # irsz # localitate # adresa # HU.
   Loguri: [NDC-WA] (RO) / [NDC-WA-HU] (HU) – fără date personale (doar lungimi/câmpuri lipsă). Mesajul RO = neschimbat. */
(function () {
  'use strict';
  var dlg = document.querySelector('[data-ndc-wa-dialog]');
  if (!dlg) { try { console.debug('[NDC-WA] fără dialog pe pagină – ies'); } catch (e) {} return; }
  var HU = dlg.dataset.lang === 'hu';
  var TAG = HU ? '[NDC-WA-HU]' : '[NDC-WA]';
  function log() { try { console.log.apply(console, [TAG].concat([].slice.call(arguments))); } catch (e) {} }
  function warn() { try { console.warn.apply(console, [TAG].concat([].slice.call(arguments))); } catch (e) {} }
  var form = dlg.querySelector('[data-ndc-wa-form]');
  var sumEl = dlg.querySelector('[data-ndc-wa-sum]');
  var errEl = dlg.querySelector('[data-ndc-wa-err]');
  var after = dlg.querySelector('[data-ndc-wa-after]');
  var PHONE = dlg.dataset.phone;
  var PRAG = 17900, TRANSPORT = 2100;
  console.log('[NDC wa-order] prag transport gratuit (bani):', PRAG, '| transport:', TRANSPORT);
  var SHIP_HU = parseInt(dlg.dataset.ship || '299000', 10);
  var CURRENCY = dlg.dataset.currency || (HU ? 'HUF' : 'RON');
  var KEY = HU ? 'ndc-wa-livrare-hu' : 'ndc-wa-livrare';
  var LINK_KEYS = ['_Vezi macheta', '_Látványterv'];
  var CONFIRM_KEYS = ['Machetă confirmată', 'Látványterv jóváhagyva'];
  var product = {};
  try { product = JSON.parse(document.querySelector('[data-ndc-wa-product]').textContent); } catch (e) { warn('JSON produs ilizibil', e); }
  var order = null, lastMsg = '', svcEls = [];
  log('init', { hu: HU, moneda: CURRENCY, variante: Object.keys(product.variants || {}).length, transport: HU ? SHIP_HU : (TRANSPORT + ' / gratuit >= ' + PRAG) });
  if (HU && CURRENCY !== 'HUF') warn('moneda paginii nu e HUF:', CURRENCY, '– sumele din mesaj vor fi greșite');

  // Serviciile bifate (Protecție colet, Livrare prioritară) intră în mesaj, NU în coș: ndc-personalizer.js le-ar adăuga
  // în coș la orice buton [data-ndc-buy]. Le dezactivăm pe durata clicului (captură pe window = înaintea personalizatorului).
  window.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('[data-ndc-wa]'))) return;
    var el = [];
    document.querySelectorAll('[data-ndc-perso] [data-ndc-service]').forEach(function (x) {
      if (x.checked && !x.disabled) { el.push(x); x.disabled = true; }
    });
    svcEls = el;
    log('clic buton WhatsApp – servicii bifate:', el.length);
    setTimeout(function () { el.forEach(function (x) { x.disabled = false; }); }, 0);
  }, true);

  function clean(s) { return String(s == null ? '' : s).replace(/[*_~`]/g, '').replace(/\s+/g, ' ').trim(); }
  function lei(c) {
    var v = Math.round(c) / 100;
    return (v % 1 ? v.toFixed(2).replace('.', ',') : String(v)) + ' lei';
  }
  // HU: 2990000 → „29 990 Ft” (forintul fără zecimale, spațiu la mii)
  function ft(c) {
    var v = Math.round(Math.round(c) / 100);
    return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft';
  }
  var money = HU ? ft : lei;
  function fnv(s) {
    var h = 0x811c9dc5;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
    return ('00000000' + h.toString(16)).slice(-8).slice(0, 6).toUpperCase();
  }
  // aceeași funcție în Apps Script (ndcWaCanon_)
  function ndcWaCanon(o) {
    return [o.v, o.s.join(','), o.p.map(function (x) { return x[0] + '=' + x[1]; }).join('|'),
      o.nume, o.judet, o.localitate, o.adresa, o.locker ? '1' : '0'].join('#');
  }
  // HU – de implementat identic în Apps Script la etapa E (ndcWaCanonHu_)
  function ndcWaCanonHu(o) {
    return [o.v, o.s.join(','), o.p.map(function (x) { return x[0] + '=' + x[1]; }).join('|'),
      o.nume, o.irsz, o.localitate, o.adresa, 'HU'].join('#');
  }

  function readOrder(formId) {
    var f = document.getElementById(formId);
    if (!f) { warn('formularul produsului lipsește:', formId); return null; }
    var fd = new FormData(f);
    var vid = String(fd.get('id') || '');
    var v = (product.variants || {})[vid];
    if (!v) { warn('varianta nu e în JSON-ul produsului:', vid); return null; }
    var props = [], link = '', linkKey = '';
    fd.forEach(function (val, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (!m) return;
      var name = m[1], value = clean(val);
      if (!value) return;
      if (LINK_KEYS.indexOf(name) >= 0) { link = String(val).trim(); linkKey = name; return; }
      if (name.charAt(0) === '_') return;
      props.push([clean(name), value]);
    });
    if (link) props.push([linkKey, link]);
    var svc = [], svcTxt = [], svcSum = 0;
    (svcEls || []).forEach(function (b) {
      var lab = b.closest('label');
      var strong = lab && lab.querySelector('strong');
      var pm = strong ? /([\d.]+(?:,\d+)?)/.exec(strong.textContent.replace(/\s/g, '')) : null;
      var price = pm ? Math.round(parseFloat(pm[1].replace(/\./g, '').replace(',', '.')) * 100) : 0;
      if (!pm) warn('prețul serviciului nu a putut fi citit din etichetă', b.value);
      var title = lab ? clean((lab.querySelector('span') || lab).firstChild.textContent) : (HU ? 'Szolgáltatás' : 'Serviciu');
      svc.push(String(b.value)); svcTxt.push(title + ' (' + money(price) + ')'); svcSum += price;
    });
    var sub = v.p + svcSum;
    var ship = HU ? SHIP_HU : (sub >= PRAG ? 0 : TRANSPORT);
    var o = { v: vid, vt: v.t, s: svc, st: svcTxt, p: props, sub: sub, ship: ship, total: sub + ship };
    log('comandă citită', { varianta: vid, proprietati: props.map(function (x) { return x[0]; }), servicii: svc, subtotal: sub, transport: ship, total: o.total, link_macheta: !!link });
    return o;
  }

  function summaryHtml(o) {
    var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
    var li = o.p.filter(function (x) { return LINK_KEYS.indexOf(x[0]) < 0 && CONFIRM_KEYS.indexOf(x[0]) < 0; })
      .map(function (x) { return '<li>' + esc(x[0]) + ': <strong>' + esc(x[1]) + '</strong></li>'; }).join('');
    o.st.forEach(function (t) { li += '<li>+ ' + esc(t) + '</li>'; });
    var head = '<strong>' + esc(product.title || '') + '</strong>' + (o.vt && o.vt !== 'Default Title' ? '<br>' + esc(o.vt) : '') +
      (li ? '<ul>' + li + '</ul>' : '');
    if (HU) {
      return head + '<p class="ndc-wa__total">Összesen: <strong>' + ft(o.total) + '</strong> ' +
        '(tartalmazza a ' + ft(o.ship) + ' szállítási díjat) – bankkártyás fizetés</p>';
    }
    return head +
      '<p class="ndc-wa__total">Total: <strong>' + lei(o.total) + '</strong> ' +
      (o.ship ? '(include transportul de ' + lei(o.ship) + ')' : '(transport gratuit)') + ' – plata la livrare</p>';
  }

  function buildMessage(o, d) {
    var L = ['Bună! Vreau să comand pe WhatsApp:', '', '*' + clean(product.title) + '*'];
    if (o.vt && o.vt !== 'Default Title') L.push(clean(o.vt));
    o.p.forEach(function (x) {
      if (x[0] === '_Vezi macheta') return;
      if (x[0] === 'Machetă confirmată') { L.push('✓ Machetă confirmată pe site'); return; }
      L.push('• ' + x[0] + ': ' + x[1]);
    });
    o.st.forEach(function (t) { L.push('+ ' + t); });
    L.push('', 'Total: *' + lei(o.total) + '* ' + (o.ship ? '(cu transport ' + lei(o.ship) + ')' : '(transport gratuit)') + ' – plata la livrare');
    L.push('', '*Livrare*', 'Nume: ' + d.nume, 'Adresă: ' + d.adresa, 'Localitate: ' + d.localitate, 'Județ: ' + d.judet);
    if (d.locker) L.push('Locker DPD: da');
    var link = o.p.filter(function (x) { return x[0] === '_Vezi macheta'; })[0];
    if (link) L.push('', 'Macheta: ' + link[1]);
    var canon = ndcWaCanon({ v: o.v, s: o.s, p: o.p, nume: d.nume, judet: d.judet, localitate: d.localitate, adresa: d.adresa, locker: d.locker });
    L.push('', 'Cod: NDC-' + o.v + o.s.map(function (s) { return '-S' + s; }).join('') + '-' + fnv(canon));
    return L.join('\n');
  }

  function buildMessageHu(o, d) {
    var L = ['Szia! WhatsAppon szeretnék rendelni:', '', '*' + clean(product.title) + '*'];
    if (o.vt && o.vt !== 'Default Title') L.push(clean(o.vt));
    o.p.forEach(function (x) {
      if (LINK_KEYS.indexOf(x[0]) >= 0) return;
      if (CONFIRM_KEYS.indexOf(x[0]) >= 0) { L.push('✓ Látványterv jóváhagyva az oldalon'); return; }
      L.push('• ' + x[0] + ': ' + x[1]);
    });
    o.st.forEach(function (t) { L.push('+ ' + t); });
    L.push('', 'Összesen: *' + ft(o.total) + '* (szállítással: ' + ft(o.ship) + ') – fizetés bankkártyával (fizetési linket küldünk)');
    L.push('', '*Szállítás*', 'Név: ' + d.nume, 'Cím: ' + d.adresa, 'Irányítószám: ' + d.irsz, 'Település: ' + d.localitate, 'Ország: Magyarország');
    var link = o.p.filter(function (x) { return LINK_KEYS.indexOf(x[0]) >= 0; })[0];
    if (link) L.push('', 'Látványterv: ' + link[1]);
    var canon = ndcWaCanonHu({ v: o.v, s: o.s, p: o.p, nume: d.nume, irsz: d.irsz, localitate: d.localitate, adresa: d.adresa });
    L.push('', 'Kód: NDC-HU-' + o.v + o.s.map(function (s) { return '-S' + s; }).join('') + '-' + fnv(canon));
    return L.join('\n');
  }

  function fields() { return HU ? ['nume', 'irsz', 'localitate', 'adresa'] : ['nume', 'judet', 'localitate', 'adresa']; }

  function loadSaved() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!s) return;
      fields().forEach(function (k) { if (s[k] && form.elements[k]) form.elements[k].value = s[k]; });
      log('datele de livrare salvate au fost completate');
    } catch (e) { warn('localStorage indisponibil', e); }
  }

  function open(formId) {
    order = readOrder(formId);
    if (!order) { warn('comanda nu a putut fi citită – deschid WhatsApp simplu'); window.open('https://wa.me/' + PHONE, '_blank'); return; }
    sumEl.innerHTML = summaryHtml(order);
    errEl.hidden = true;
    form.hidden = false;
    after.hidden = true;
    loadSaved();
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    log('fereastra deschisă');
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ndc-wa]');
    if (!b || e.defaultPrevented) { if (b) log('clic oprit de personalizator (text/machetă neconfirmate)'); return; }
    e.preventDefault();
    open(b.dataset.formId);
  });
  dlg.querySelector('[data-ndc-wa-close]').addEventListener('click', function () { dlg.close(); log('fereastra închisă (×)'); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) { dlg.close(); log('fereastra închisă (fundal)'); } });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var d, lipsa = [];
    if (HU) {
      d = {
        nume: clean(form.elements.nume.value), irsz: clean(form.elements.irsz.value).replace(/\s/g, ''),
        localitate: clean(form.elements.localitate.value), adresa: clean(form.elements.adresa.value)
      };
      if (d.nume.split(' ').length < 2) lipsa.push('a teljes nevet');
      if (!/^\d{4}$/.test(d.irsz)) lipsa.push('az irányítószámot (4 számjegy)');
      if (d.localitate.length < 2) lipsa.push('a települést');
      // 20.10 (G5): Cím fără număr (ex. „Petőfi utca”) = colet nelivrabil → cerem și házszámot; log fără date personale
      if (d.adresa.length < 4) lipsa.push('a címet');
      else if (!/\d/.test(d.adresa)) { lipsa.push('a házszámot is a címben (pl. Petőfi utca 12)'); log('validare: adresa fără număr', { caractere: d.adresa.length }); }
      if (lipsa.length) { errEl.textContent = 'Kérjük, add meg ' + lipsa.join(', ') + '.'; errEl.hidden = false; log('validare: lipsesc', lipsa.length, 'câmpuri'); return; }
    } else {
      d = {
        nume: clean(form.elements.nume.value), judet: clean(form.elements.judet.value),
        localitate: clean(form.elements.localitate.value), adresa: clean(form.elements.adresa.value),
        locker: form.elements.locker.checked
      };
      if (d.nume.split(' ').length < 2) lipsa.push('numele și prenumele');
      if (!d.judet) lipsa.push('județul');
      if (d.localitate.length < 2) lipsa.push('localitatea');
      if (d.adresa.length < 4) lipsa.push('adresa');
      if (lipsa.length) { errEl.textContent = 'Completează ' + lipsa.join(', ') + '.'; errEl.hidden = false; log('validare: lipsesc', lipsa.length, 'câmpuri'); return; }
    }
    try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (x) { warn('nu pot salva datele de livrare', x); }
    lastMsg = HU ? buildMessageHu(order, d) : buildMessage(order, d);
    var codLine = lastMsg.split('\n').pop();
    log('mesaj construit', { caractere: lastMsg.length, cod: codLine, total: order.total, moneda: CURRENCY });
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('ndc_whatsapp_order', { value: order.total / 100, currency: CURRENCY, variant_id: order.v, market: HU ? 'HU' : 'RO' });
        log('analytics ndc_whatsapp_order trimis', CURRENCY);
      }
    } catch (x) { warn('analytics eșuat', x); }
    var url = 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(lastMsg);
    form.hidden = true;
    after.hidden = false;
    var w = window.open(url, '_blank');
    if (!w) { warn('pop-up blocat – navighez direct la WhatsApp'); window.location.href = url; }
    else log('WhatsApp deschis');
  });

  dlg.querySelector('[data-ndc-wa-copy]').addEventListener('click', function (e) {
    var btn = e.currentTarget;
    var done = function () { btn.textContent = HU ? 'Másolva ✓' : 'Copiat ✓'; log('mesaj copiat'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(lastMsg).then(done, function (x) { warn('copiere eșuată', x); });
    else { var t = document.createElement('textarea'); t.value = lastMsg; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); done(); } catch (x) { warn('copiere eșuată', x); } t.remove(); }
  });
})();